import React from 'react';
import Col from 'react-bootstrap/Col';
import HelpTooltip from 'components/overlays/helpTooltip/HelpTooltip';
import BzmSearchInput from 'components/forms/BzmSearchInput/BzmSearchInput';
import BzmIcon from 'components/icons/BzmIcon';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import { formatDateAndTime } from 'utils/dateUtil';
import Button from 'react-bootstrap/Button';
import { MsType, SV } from 'types/rest/mockServiceTypes';

type InspectionHeaderProps = {
  requests: any[];
  searchKeyword: string;
  onSearchKeywordChanged: (keyword: string) => void;
  lastRefresh: any;
  refreshHandler: () => void;
  title: string;
  searchPlaceHolder?: string;
  msType: MsType;
};

const InspectionHeader = (props: InspectionHeaderProps) => {
  const { t } = useTranslation('analytics');
  const { lastRefresh, searchKeyword, requests } = props;
  const helpId = props.msType === SV ? 'ms-analytics-help' : 'analytics-transaction-help';
  return (
    <Row className="mt-4">
      <Col lg={6} md={4} sm={12}>
        <h2 className={'mb-2'}>
          {props.title} ({requests ? requests.length : 0})
          <HelpTooltip
            id={helpId}
            title={t('common:showHelp')}
            className="ml-3"
            fontSize={22}
            style={{ position: 'relative', top: '2px' }}
          />
        </h2>
      </Col>
      <Col lg={6} md={8} sm={12}>
        <div className="float-right ml-4" style={{ position: 'relative', bottom: '4px' }}>
          <BzmSearchInput
            value={searchKeyword}
            placeholder={props.searchPlaceHolder ? props.searchPlaceHolder : t('inspection.header.searchRequest')}
            onChange={props.onSearchKeywordChanged}
          />
        </div>

        <div className="float-right" style={{ position: 'relative', bottom: '4px' }}>
          <Button
            variant="primary"
            onClick={props.refreshHandler}
            title={t('inspection.header.refreshRequest')}
            style={{ height: '30px' }}
          >
            <BzmIcon variant="icon-bzm-sync"></BzmIcon>
            <span className="ml-2">{t('inspection.header.refresh')}</span>
          </Button>
        </div>
        <div className="float-right mr-4 mt-1" style={{ position: 'relative' }}>
          {lastRefresh !== null && (
            <>
              {t('inspection.header.lastRefresh')}:
              <strong className="ml-2">{formatDateAndTime(lastRefresh, true)}</strong>
            </>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default InspectionHeader;
